
export const TOGGLE_VISUALSEARCH_GRAYSCALE = 'grayscale-visualsearch/TOGGLE';

export const VISUALSEARCH_SET_IMAGE = 'VISUALSEARCH_SET_IMAGE';
export const VISUALSEARCH_SET_LUMINANCE = 'VISUALSEARCH_SET_LUMINANCE';
export const VISUALSEARCH_SET_CROP_IMAGE = 'VISUALSEARCH_SET_CROP_IMAGE';

export interface VisualSearchResultAction {
  type: string;
  enableGrayScale?: boolean;
  imageLoaded?: boolean;
  imageSrc?: string;
  imageData?: Uint8Array;
  luminanceSearch?: boolean;
  useCropSearch?: boolean;
  cropImageSrc?: string;
  cropImageData?: Uint8Array;
}

export function toggleVisualSearchGrayScale(enableGrayScale: boolean): VisualSearchResultAction {
  return {
    type: TOGGLE_VISUALSEARCH_GRAYSCALE,
    enableGrayScale: enableGrayScale
  };
}

export function setVisualSearchImage(imageLoaded: boolean, imageSrc: string, imageData: Uint8Array): VisualSearchResultAction {
  return {
    type: VISUALSEARCH_SET_IMAGE,
    imageLoaded: imageLoaded,
    imageSrc: imageSrc,
    imageData: imageData,
    useCropSearch: false,
    cropImageSrc: '',
    cropImageData: null,
  };
}

export function setVisualSearchLuminance(luminanceSearch: boolean): VisualSearchResultAction {
  return {
    type: VISUALSEARCH_SET_LUMINANCE,
    luminanceSearch: luminanceSearch
  };
}

export function setVisualSearchCropImage(useCropSearch: boolean, cropImageSrc: string, cropImageData: Uint8Array): VisualSearchResultAction {
  return {
    type: VISUALSEARCH_SET_CROP_IMAGE,
    useCropSearch: useCropSearch,
    cropImageSrc: cropImageSrc,
    cropImageData: cropImageData,
  };
}
